import { logError } from 'api/errors';
import { getMessage } from 'util/locale';

export const getCategoryDisplayName = (categoryCode, unlocalizedName) => {
  let displayName;
  if (categoryCode === 'planting') {
    displayName = getMessage('label-text__activity--planting--planting');
  } else if (categoryCode === 'application') {
    displayName = getMessage('label-text__activity--application--application');
  } else {
    displayName = getMessage(`label-text__activity--fertility-${categoryCode}`);
  }
  
  if (displayName && displayName !== '') { return displayName; }

  /* Either service responded with something unexpected or need to update localized texts. 
     Log an error and return something usable. */
  logError(`No localized text available for "${categoryCode}" activity category.`);
  return unlocalizedName;
};
